import { Reducer } from 'redux';
import ActionTypes, { TTechnicalTextsState } from './types';

export const initialState: TTechnicalTextsState = {
  error: null,
  data: null,
  loading: false,
};

const reducer: Reducer<TTechnicalTextsState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_TECHNICAL_TEXTS_R:
      return { ...state, loading: true, error: null };
    case ActionTypes.GET_TECHNICAL_TEXTS_S:
      return { ...state, data: action.payload, loading: false, error: null };
    case ActionTypes.GET_TECHNICAL_TEXTS_E:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export { reducer as TechnicalTextsReducer };
